(function () {
  // this is Fitle add to cart handler
  document.addEventListener('jc-cart:reload', function (evt) {
    //evt.detail value is null. So this is how we can get the product  identifier and size added to cart
    const product_id = window.meta.product.id
    if (!product_id) return;

    let size = '';
    let sizeElement = document.querySelector('div.product-variant span.jc-text-sonicsilver');
    if (sizeElement && sizeElement.innerText) {
      size = sizeElement.innerText;
    }

    ftltag('event', 'cart', { product_id, size });

  });
})();

